<mat-drawer-container class="example-container" hasBackdrop="false">
  <mat-drawer
    id="drawer"
    [opened]="menuStatus"
    #drawer
    position="end"
    mode="over"
  >
  
    <app-list
      *ngIf="dimana === 'list'"
      [feature]="home"
      [menuStatus]="menuStatus"
      (menuChange)="changeMenuStatus($event)"
      (dimanaChange)="changeDimana($event)"
      (detailChange)="changeDetail($event)"
      [dimana]="dimana"
      [layers]="layers"
      [map]="map"
    ></app-list>
    <app-detail
      *ngIf="dimana === 'detail'"
      [detai]="laye"
      (editChange)="changeDetail($event)"
      (dimanaChange)="changeDimana($event)"
      [menuStatus]="menuStatus"
      (menuChange)="changeMenuStatus($event)"
      [dimana]="dimana"
      (removeLayeChange)="changeRemoveLaye($event)"
    ></app-detail>
    <app-edit
    [detai]="laye"
    (layeChange)="changeLaye($event)"
      *ngIf="dimana === 'edit'"
      (dimanaChange)="changeDimana($event)"
      [menuStatus]="menuStatus"
      (menuChange)="changeMenuStatus($event)"
      [dimana]="dimana"
      [layers]="layers"
      (removeLayeChange)="changeRemoveLaye($event)"
    ></app-edit>
    <app-add
    [laye]="laye"
      *ngIf="dimana === 'add'"
      (removeLayeChange)="changeRemoveLaye($event)"
      (layeChange)="changeLaye($event)"
      (dimanaChange)="changeDimana($event)"
      [menuStatus]="menuStatus"
      (menuChange)="changeMenuStatus($event)"
      [dimana]="dimana"
    ></app-add>
  </mat-drawer>
  <mat-drawer-content>
    <button
      color="primary"
      *ngIf="!menuStatus"
      (click)="toggleMenu()"
      style="position:absolute;z-index:99999;float:right;right:0;margin:10px;"
      mat-fab
      aria-label="Example icon-button with a heart icon"
    >
      <mat-icon>dehaze</mat-icon>
    </button>

    <div id="map"></div>
  </mat-drawer-content>
</mat-drawer-container>
